'use client';

import Image from 'next/image';
import emaillogin from './../../public/icons/emaillogin.svg';
import facebooklogin from './../../public/icons/facebooklogin.svg';
import googlelogin from './../../public/icons/googlelogin.svg';
import linkedinlogin from './../../public/icons/linkedinlogin.svg';
import React, { useContext, useState } from "react";
import { useRouter } from 'next/navigation';
import '@/scss/login.scss';
import { forgotPasswordAPI, googleLoginAPI, linkedinLoginAPI, loginAPI, registerAPI, resetPasswordAPI } from '@/services/userService';
import UserContext from '@/context/userContext';
import { dismissToast, showSuccess, showLoading, showError } from '@/utils/toast';

export default function LoginPopUpPage({ onClose, initialScreen = 'welcome-back' }) {
  const context = useContext(UserContext);
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [currentScreen, setCurrentScreen] = useState(initialScreen);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    newPassword: '',
    confirmPassword: '',
    otp: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleContinue = (screen) => {
    setCurrentScreen(screen);
  };

  const handleGoBack = (screen) => {
    setCurrentScreen(screen);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      // Navigate back or close modal
      window.history.back();
    }
  };

  // Login Function
  const loginFun = async () => {
    try {
      const loadingToastId = showLoading("Logging in...");
      const response = await loginAPI({ email, password });
      if (response.token) {
        context.login(response.user, response.token);
        setTimeout(() => {
          dismissToast(loadingToastId);
          showSuccess(response.message + " Welcome back!");
          setTimeout(() => {
            onClose();
          }, 1000)
        }, 1500);
      } else {
        console.error('Login failed');
      }
    } catch (error) {
      // console.error('Error logging in:', error);
    }
  }

  //Register Function
  const registerFun = async () => {
    try {
      setIsSubmitting(true);
      const response = await registerAPI({ name, email, password });
      if (response.message) {
        showSuccess(response.message);
      }
      handleContinue('email-verification')
    } catch (error) {
      console.error('Error registering:', error);
    } finally {
      setIsSubmitting(false);
    }
  }

  // Forgot Password - request an OTP
  const forgotPasswordFun = async () => {
    if (!formData.email) {
      showError('Please enter your email.');
      return;
    }
    try {
      setIsSubmitting(true);
      const response = await forgotPasswordAPI({ email: formData.email });
      if (response.status === 200) {
        showSuccess(response.message);
        handleContinue('reset-password');
      }
    } catch (error) {
      // Error toast handled by HttpHelper interceptor
    } finally {
      setIsSubmitting(false);
    }
  }

  // Reset Password - submit OTP and new password
  const resetPasswordFun = async () => {
    if (!formData.otp || !formData.newPassword || !formData.confirmPassword) {
      showError('Please fill in all fields.');
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      showError('Passwords do not match.');
      return;
    }
    try {
      setIsSubmitting(true);
      const response = await resetPasswordAPI({
        email: formData.email,
        otp: formData.otp,
        new_password: formData.newPassword,
        new_password_confirmation: formData.confirmPassword,
      });
      if (response.status === 200) {
        showSuccess(response.message);
        setFormData((prev) => ({ ...prev, newPassword: '', confirmPassword: '', otp: '' }));
        handleContinue('signin-email');
      }
    } catch (error) {
      // Error toast handled by HttpHelper interceptor
    } finally {
      setIsSubmitting(false);
    }
  }

  // Social Login
  const socialLoginFun = async (text) => {
    if(text == 'g') {
      try {
        const result = await googleLoginAPI();
        if(result.status === 200) {
          window.location.href = result.data.redirect_url;
        } else {
          showError(result.message);
        }
      } catch (error) {
        console.error('Error logging in with Google:', error);
      }
    } else if (text == 'l') {
      try {
        const result = await linkedinLoginAPI();
        if(result.status === 200) {
          window.location.href = result.data.redirect_url;
        } else {
          showError(result.message);
        }
      } catch (error) {
        console.error('Error logging in with LinkedIn:', error);
      }
    }
  }


  return (
    <div className="login-page-wrapper">
      {/* Screen 1: Welcome Back! */}
      {currentScreen === 'welcome-back' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image oil-field-bg-1"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title bold-heading">Welcome Back!</h2>
                <div className="social-buttons-container">
                  <button className="social-btn" onClick={() => handleContinue('signin-email')}>
                    <Image src={emaillogin} alt='emaillogin' />
                    <span>Sign in with Email</span>
                  </button>
                  <button className="social-btn" onClick={() => socialLoginFun('g')}>
                    <Image src={googlelogin} alt='googlelogin' />
                    <span>Sign in with Gmail</span>
                  </button>
                  {/* <button className="social-btn" onClick={() => handleContinue('signin-email')}>
                    <Image src={facebooklogin} alt='facebooklogin' />
                    <span>Sign in with Facebook</span>
                  </button> */}
                   <button className="social-btn" onClick={() => socialLoginFun('l')}>
                    <Image src={linkedinlogin} alt='linkedinlogin' />
                    <span>Sign in with LinkedIn</span>
                  </button>
                </div>
                <p className="signup-link-text">
                  Don't have an account? <span className="link-text" onClick={() => handleContinue('join-invest')}>Sign up</span>
                </p>
                <p className="disclaimer-text">
                  By creating an account you agree to our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Screen 2: Sign in with Email */}
      {currentScreen === 'signin-email' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image oil-field-bg-2"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title">Sign in with email</h2>
                <div className="form-group">
                  <label className="form-label">Your Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control-custom"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}

                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Password *</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control-custom"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {showPassword ? (
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        ) : (
                          <>
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="3" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <div className="remember-forgot-wrapper">
                    <label className="checkbox-label">
                      <input type="checkbox" className="checkbox-input" />
                      <span>Remember me?</span>
                    </label>
                    <button
                      type="button"
                      className="forgot-password-link"
                      onClick={() => handleContinue('forgot-password')}
                    >
                      Forgot Password?
                    </button>
                  </div>
                </div>
                {/* <div className="form-group empty-space"></div> */}
                <button className="btn-continue" onClick={() => { loginFun() }}>
                  Continue
                </button>
                <button className="link-back" onClick={() => handleContinue('welcome-back')}>
                  &lt; All sign up options
                </button>
                <p className="disclaimer-text">
                  By creating an account you agree with our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Screen 3: Forgot Password? */}
      {currentScreen === 'forgot-password' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image oil-pump-bg-1"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title">Forgot Password?</h2>
                <div className="form-group">
                  <label className="form-label">Your Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control-custom"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
                <button className="btn-continue" onClick={() => forgotPasswordFun()} disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Continue'}
                </button>
                <button className="link-back" onClick={() => handleContinue('signin-email')}>
                  &lt; Go Back
                </button>
                <p className="disclaimer-text">
                  By creating an account you agree with our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Screen 4: Reset your password */}
      {currentScreen === 'reset-password' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image oil-pump-bg-2"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title">Reset your password</h2>
                <p className="login-subtitle">Enter the OTP sent to {formData.email} and choose a new password.</p>
                <div className="form-group">
                  <label className="form-label">OTP *</label>
                  <input
                    type="text"
                    name="otp"
                    inputMode="numeric"
                    maxLength={6}
                    className="form-control-custom"
                    placeholder="Enter the 6-digit code"
                    value={formData.otp}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">New Password *</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="newPassword"
                      className="form-control-custom"
                      placeholder="Password"
                      value={formData.newPassword}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {showPassword ? (
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        ) : (
                          <>
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="3" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm New Password *</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="confirmPassword"
                      className="form-control-custom"
                      placeholder="Re-enter password"
                      value={formData.confirmPassword}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <button className="btn-continue" onClick={() => resetPasswordFun()} disabled={isSubmitting}>
                  {isSubmitting ? 'Resetting...' : 'Continue'}
                </button>
                <button className="link-back" onClick={() => handleContinue('forgot-password')}>
                  &lt; Go Back
                </button>
                <p className="disclaimer-text">
                  By creating an account you agree with our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Screen 5: Sign up with email */}
      {currentScreen === 'signup-email' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image refinery-bg-1"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title">Sign up with email</h2>
                <p className="login-subtitle">Enter your details to create an account</p>
                <div className="form-group">
                  <label className="form-label">Name *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control-custom"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Your Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control-custom"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Password *</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control-custom"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {showPassword ? (
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        ) : (
                          <>
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="3" stroke="#A3ABB1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label className="checkbox-label">
                    <input type="checkbox" className="checkbox-input" />
                    <span>Remember me?</span>
                  </label>
                </div>
                {/* <div className="form-group empty-space"></div> */}
                <button className="btn-continue" onClick={() => registerFun()} disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Continue'}
                </button>
                <button className="link-back" onClick={() => handleContinue('join-invest')}>
                  &lt; All sign up options
                </button>
                <p className="disclaimer-text">
                  By creating an account you agree with our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Screen 6: Join Invest In Energy! */}
      {currentScreen === 'join-invest' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image refinery-bg-2"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <button className="close-btn" onClick={handleClose}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
                <h2 className="login-title bold-heading">Join Invest In Energy!</h2>
                <div className="social-buttons-container">
                  <button className="social-btn" onClick={() => handleContinue('signup-email')}>
                    <Image src={emaillogin} alt='emaillogin' />
                    <span>Sign up with Email</span>
                  </button>
                  <button className="social-btn" onClick={() => socialLoginFun('g')}>
                    <Image src={googlelogin} alt='googlelogin' />
                    <span>Sign up with Gmail</span>
                  </button>
                  {/* <button className="social-btn" onClick={() => handleContinue('signup-email')}>
                    <Image src={facebooklogin} alt='facebook' />
                    <span>Sign up with Facebook</span>
                  </button> */}
                  <button className="social-btn" onClick={() => socialLoginFun('l')}>
                    <Image src={linkedinlogin} alt='linkedinlogin' />
                    <span>Sign up with LinkedIn</span>
                  </button>
                </div>
                <p className="signup-link-text">
                  Already have an account? <span className="link-text" onClick={() => handleContinue('welcome-back')}>Sign in</span>
                </p>
                <p className="disclaimer-text">
                  By creating an account you agree to our Terms of Service, Privacy Policy, and our default Notification Settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Screen 7: Email Verification */}
      {currentScreen === 'email-verification' && (
        <div className="login-modal-container">
          <div className="login-modal-card">
            <div className="login-image-section">
              <div className="login-bg-image refinery-bg-3"></div>
            </div>
            <div className="login-form-section">
              <div className='middle-wrapper'>
                <div className="verification-content">
                  <h2 className="verification-title">Time to dive into your inbox</h2>
                  <p className="verification-text">
                    Just click on the link we sent to {email} to log in.
                  </p>
                  <button className="btn-ok" onClick={handleClose}>
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

